export const travellerDetailData = {
  title: {
    text: { value: "Add Travellers" },
  },
  travellerPlanInfo: {
    icon: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_5273_1299494d83.png",
    title: "Great Choice!",
    text: [
      {
        value: "90% of the travellers to Thailand ",
        styles: {
          color: "#fff",
          fontWeight: "bold",
        },
      },
      {
        value: "have bought this Insurance",
        styles: {
          color: "#fff",
        },
      },
    ],
  },
  planInfo: {
    planType: {
      text: {
        value: "INSURANCE",
        styles: {
          color: "#CC2C64",
        },
      },
    },
    planName: {
      text: {
        value: "Tripmoney Tourer Plus Advanced Insurance",
        styles: {
          color: "#fff",
        },
      },
    },
    sumInsured: {
      text: {
        value: "Sum Insured Per Person: $ 50,000",
        styles: {
          color: "#fff",
        },
      },
    },
    amountToPay: {
      text: [
        {
          value: "Amount to pay :  ",
          styles: null,
        },
        {
          value: "₹ 498",
          styles: {},
        },
      ],
    },
  },
  travellerDetail: {
    title: "Add Traveller Details",
    info: "Senior citizens 70yrs and above are not covered",
  },
  primaryContact: {
    title: "Primary Contact Details",
    info: "All the communication regarding to the insurance will be shared to this contact.",
    fields: {
      mobile: {
        countryCode: "91",
        errorMessage: "Please enter valid Mobile No.",
        placeholder: "Enter 10 Digit Mobile No.",
        fieldName: "mobile",
        isRequired: true,
        regex: "^[1-9][0-9]{5,14}$",
        title: "10 Digit Mobile No.",
        value: "6460672974",
      },
      email: {
        errorMessage: "Please enter valid email",
        fieldName: "email",
        isRequired: true,
        regex: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
        title: "Email ID",
        placeholder: "Enter Email ID",
        value: "goodmanwatches@gmail.com",
      },
    },
  },
  secondaryContact: {
    title: "Traveller",
    fields: {
      name: {
        errorMessage: "Please enter valid Name",
        fieldName: "Name",
        placeholder: "Full Name",
        isRequired: true,
        regex: "^.{3,}$",
        title: "FULL NAME",
        value: "",
      },
      dob: {
        errorMessage: "Please enter valid Date of Birth",
        fieldName: "DOB",
        isRequired: true,
        regex:
          "^(?:0[1-9]|[12]\\d|3[01])([/.-])(?:0[1-9]|1[012])\\1(?:19|20)\\d\\d$",
        title: "DATE OF BIRTH",
        placeholder: "dd/mm/yyy",
        value: "",
      },
      gender: {
        fieldName: "Gender",
        isRequired: true,
        title: "Gender",
        values: [
          {
            label: "Male",
            id: "1",
            isSelected: false,
          },
          {
            label: "Female",
            id: "2",
            isSelected: false,
          },
          {
            label: "Others",
            id: "3",
            isSelected: false,
          },
        ],
      },
    },
  },
  concent: {
    tnc: {
      title: {
        text: [
          {
            value:
              "By Proceeding, I confirm that all travellers are Indian Citizens & below 70 years of age. Also, I agree to all the ",
            styles: null,
          },
          {
            value: "Terms & Conditions.",
            styles: null,
          },
        ],
      },
      url: "",
    },
    info: "Go-MMT hereby disclaims warranties of any kind, whether express or implied, including the warranty of title, merchantability, non-infringement and fitness for a particular purpose with regard to the travel insurances available on its platform. Go-MMT makes available the travel insurance as a group administrator and thus, Go-MMT is not responsible and liable for the travel insurance policies provided by the insurance providers.",
  },
  note: {
    title: {
      text: {
        value: "Please note*",
        styles: {},
      },
    },
    info: {
      text: {
        value:
          "The passport details and nominee details have to be added post insurance purchase to generate the policy document.",
        styles: null,
      },
    },
  },
  upcomingTravellerDetails: [
    {
      name: "Anusha",
      dob: "",
      gender: "Female",
    },
  ],
  tnc: {
    title: "T&C Apply",
    url: "https://www.google.com",
  },
  totalAmt: "₹ 498",
};
